/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RepairmanListItemVm,
    RepairmanListItemVmFromJSON,
    RepairmanListItemVmFromJSONTyped,
    RepairmanListItemVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepairmanListItemVmPaginatedSearchResponse
 */
export interface RepairmanListItemVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<RepairmanListItemVm>}
     * @memberof RepairmanListItemVmPaginatedSearchResponse
     */
    items?: Array<RepairmanListItemVm> | null;
    /**
     * 
     * @type {number}
     * @memberof RepairmanListItemVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairmanListItemVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairmanListItemVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairmanListItemVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairmanListItemVmPaginatedSearchResponse
     */
    size?: number;
}

export function RepairmanListItemVmPaginatedSearchResponseFromJSON(json: any): RepairmanListItemVmPaginatedSearchResponse {
    return RepairmanListItemVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function RepairmanListItemVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepairmanListItemVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(RepairmanListItemVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function RepairmanListItemVmPaginatedSearchResponseToJSON(value?: RepairmanListItemVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(RepairmanListItemVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


